import { isHttpErrorDetailsPayload } from '@unipile/types';
import { Alert, AlertDescription, AlertTitle, Spinner, getBrandFont, useHostedAuthSession } from '@unipile/ui';
import { isAxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { ProviderSelectionContainer } from '../components/screens/ProviderSelection';
import { hexToHSL, hexToHSLString } from '../utils/hex-to-hsl';

export function Wizard() {
  const { data: session, isError, isSuccess, error } = useHostedAuthSession();
  const { t } = useTranslation();

  if (isError) {
    const errorDetails = isAxiosError(error) && isHttpErrorDetailsPayload(error.response?.data) ? error.response.data : undefined;

    return (
      <Alert variant="red">
        <AlertTitle>{errorDetails?.title || t('Error')}</AlertTitle>
        <AlertDescription>{errorDetails?.detail || t('Error.unexpected')}</AlertDescription>
      </Alert>
    );
  }

  if (isSuccess) {
    const font = getBrandFont(session.brand_font);

    return (
      <>
        {font.stylesheet_url && <link rel="stylesheet" href={font.stylesheet_url} />}
        <style>
          {`
            :root {
              font-family: ${font.font_family};
              ${
                session.brand_shapes &&
                `--radius: ${session.brand_shapes === 'rounded' ? '0.5rem' : session.brand_shapes === 'pill' ? '30px' : '0'};`
              }
              ${session.brand_primary_color && `--primary: hsl(${hexToHSLString(session.brand_primary_color)});`}
              ${session.brand_primary_color && `--primary-foreground: hsl(${hexToHSL(session.brand_primary_color).l < 70 ? hexToHSLString('#ffffff') : hexToHSLString('#000000')});`}
            }
          `}
        </style>
        <ProviderSelectionContainer session={session} />
      </>
    );
  }

  return (
    <div>
      <Spinner />
    </div>
  );
}
